import {
  SUB_NAVIGATION_REQUEST,
  SUB_NAVIGATION_SUCCESS,
  SUB_NAVIGATION_ERROR,
  SET_SUB_NAV_CATEGORY_IDS,
  SET_BROWSE_SHOP_NAV_CATEGORY_IDS,
  UPDATE_PROMO_LINKS,
} from '../actions/navigation';
import {
  SET_USER_EVENT_TYPE_MOUSE,
  SET_USER_EVENT_TYPE_TOUCH,
} from '../actions/eventTypes';

export const initialState = {
  promos: [],
  isFetching: false,
  subNavigationCategoryTree: [],
  subNavCategoryIds: [],
  browseShopNavCategoryIds: [],
  lastEventType: 'mouse',
};

export default function navigation(state = initialState, action) {
  switch (action.type) {
    case SUB_NAVIGATION_REQUEST:
      return { ...state, isFetching: true };
    case SUB_NAVIGATION_SUCCESS:
      return { ...state, isFetching: false, subNavigationCategoryTree: action.data };
    case SUB_NAVIGATION_ERROR:
      return { ...state, isFetching: false, error: action.error };
    case SET_USER_EVENT_TYPE_MOUSE:
      if (state.lastEventType !== 'mouse') {
        return { ...state, lastEventType: 'mouse' };
      }
      return state;
    case SET_USER_EVENT_TYPE_TOUCH:
      if (state.lastEventType !== 'touch') {
        return { ...state, lastEventType: 'touch' };
      }
      return state;
    case SET_SUB_NAV_CATEGORY_IDS:
      return { ...state, subNavCategoryIds: action.categoryIds };
    case SET_BROWSE_SHOP_NAV_CATEGORY_IDS:
      return { ...state, browseShopNavCategoryIds: action.categoryIds };
    case UPDATE_PROMO_LINKS: {
      return { ...state, promos: action.promos };
    }
    default:
      return state;
  }
}
